// JS for the index page

import './main';
import './partials/nav'
import './partials/animations'
import './partials/contact'

document.addEventListener('DOMContentLoaded', function() {
    // GENERAL CODE FOR THIS PAGE GOES HERE
});
